import { UNIT } from '../../../../constant/unit'
import { appMessages as messages } from '../../../../messages'

import {
  HEIGHT_MAX_IMPERIAL_HEIGHT,
  HEIGHT_MAX_METRIC_HEIGHT,
  HEIGHT_MIN_IMPERIAL_HEIGHT,
  HEIGHT_MIN_METRIC_HEIGHT
} from '../../../../modules/height/constants/unit'
import { PROFILE_KEY } from '../../constants'
import createValidationElementUtil from '../../../../modules/redux/utils/create-validation-element'
import { getValueReduxUtil } from '../../../../modules/redux/utils/get-value'

function heightImperialValidator (value) {
  if (value < HEIGHT_MIN_IMPERIAL_HEIGHT) {
    return createValidationElementUtil(
      PROFILE_KEY.HEIGHT, messages.minimum, {
        key: PROFILE_KEY.HEIGHT,
        min: HEIGHT_MIN_IMPERIAL_HEIGHT
      }
    )
  }
  if (value > HEIGHT_MAX_IMPERIAL_HEIGHT) {
    return createValidationElementUtil(
      PROFILE_KEY.HEIGHT, messages.maximum, {
        key: PROFILE_KEY.HEIGHT,
        max: HEIGHT_MAX_IMPERIAL_HEIGHT
      }
    )
  }
  return true
}

function heightMetricValidator (value) {
  if (value < HEIGHT_MIN_METRIC_HEIGHT) {
    return createValidationElementUtil(
      PROFILE_KEY.HEIGHT, messages.minimum, {
        key: PROFILE_KEY.HEIGHT,
        min: HEIGHT_MIN_METRIC_HEIGHT
      }
    )
  }
  if (value > HEIGHT_MAX_METRIC_HEIGHT) {
    return createValidationElementUtil(
      PROFILE_KEY.HEIGHT, messages.maximum, {
        key: PROFILE_KEY.HEIGHT,
        max: HEIGHT_MAX_METRIC_HEIGHT
      }
    )
  }
  return true
}

function heightProfileValidatorUtil (value, options) {
  const { instance } = options
  const heightUnit = getValueReduxUtil(instance, PROFILE_KEY.HEIGHT_UNIT)
  if (typeof value === 'string') {
    value = parseFloat(value)
  }
  if (heightUnit === UNIT.METRIC) {
    return heightMetricValidator(value)
  }
  return heightImperialValidator(value)
}

export default heightProfileValidatorUtil
